// This file is used to get the holidays for a given year.
// TODO find a way to not hardcode these

const holidays2025 = [
  '2025-01-01', // "New Year's Day"
  '2025-01-20', // 'Martin Luther King, Jr. Day'
  '2025-05-26', // 'Memorial Day'
  '2025-07-04', // 'Independence Day'
  '2025-09-01', // 'Labor Day'
  '2025-11-27', // 'Thanksgiving Day'
  '2025-12-25', // 'Christmas Day'
];

const holidays2026 = [
  '2026-01-01', // "New Year's Day"
  '2026-01-19', // 'Martin Luther King, Jr. Day'
  '2026-05-25', // 'Memorial Day'
  '2026-07-03', // 'Independence Day'
  '2026-09-07', // 'Labor Day'
  '2026-11-26', // 'Thanksgiving Day'
  '2026-12-25', // 'Christmas Day'
];

export const fnHolidays = [...holidays2025, ...holidays2026];
